<script setup lang="ts">
import { useStationDataStore } from '~/stores/stations'
import CardStatWrapper from '~/components/layout/CardStatWrapper.vue'
import CardStat from '~/components/card/CardStat.vue'
import RegionsStatisticsSection from '~/components/region-statistics/RegionsStatisticsSection.vue'
import { RegionType } from '~/types/types'

const props = defineProps<{ regionType?: RegionType; regionId?: string }>()

const stationStore = useStationDataStore()
const { keyTranslator: fuelTypeGroupTranslator } = await useKeyTranslator('fuelTypeGroup')

const stationCountByFuelTypeOrigin = computed(() => {
  if (!props.regionType || !props.regionId) {
    return stationStore.getStationsGropedByFuelTypeGroup
  } else {
    return stationStore.getStationsGropedByFuelTypeGroupByRegion(props.regionType, props.regionId)
  }
})

const stationCountByFuelTypeGroup = computed(() => {
  return stationCountByFuelTypeOrigin.value
    .map((item) => ({
      label: fuelTypeGroupTranslator(item.fuelTypeGroup),
      value: item.stationCount,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
})

const isLoading = computed(() => {
  return stationStore.stationsPending || stationStore.stations.length === 0
})
</script>
<template>
  <AppLoadingWrapper :is-loading="isLoading" :height="100">
    <CardStatWrapper>
      <CardStat
        v-for="(fuelTypeGroup, i) in stationCountByFuelTypeGroup"
        :key="i"
        :label="fuelTypeGroup.label"
        :value="fuelTypeGroup.value"
      />
    </CardStatWrapper>
  </AppLoadingWrapper>
</template>
